export default "__VITE_ASSET__4bfb3b77__"